import CfpSelect from './CfpSelect'

interface FancySelectPicker3Props {
  labels: string[]
  options: string[]
  value: string
  onChange: (value: string) => void
  title?: string
  placeholder?: string
  showClear?: boolean
}

// Thin compatibility wrapper around CfpSelect so callers using the legacy
// labels[]/options[] API don't have to change.
export default function FancySelectPicker3({
  labels, options, value, onChange, title, placeholder, showClear = false,
}: FancySelectPicker3Props) {
  const opts = options.map((opt, i) => ({ value: opt, label: labels[i] ?? opt }))
  return (
    <CfpSelect
      label={title}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      options={opts}
      clearable={showClear}
    />
  )
}
